/** @jsxImportSource theme-ui */
import React, { useEffect, useRef, useState } from 'react';
import Button from '@/components/Button';

const SENT_FEEDBACK_MS = 2000;

interface Props {
    label: string;
    disabled: boolean;
    onSend: () => boolean;
}

const SendCommandButton: React.FC<Props> = ({ label, disabled, onSend }) => {
    const [isSent, setIsSent] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const handleClick = () => {
        if (!onSend()) return;
        setIsSent(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setIsSent(false), SENT_FEEDBACK_MS);
    };

    return (
        <Button type="button" variant="secondary" disabled={disabled} onClick={handleClick}>
            {isSent ? 'Sent!' : label}
        </Button>
    );
};

export default SendCommandButton;
